<p-confirmDialog key="confirmsettings" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="settings" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Email-->
<div class="MainBorder">
	<div class="Center">
		<h4>Email</h4>
	</div>

	<div class="Grid3Col TopMargin">
		<input class="form-control" type="text" [(ngModel)]="EMailAddress" />

		<label>&#64;</label>

		<select class="FlexItem form-control" name="EmailProvider" [(ngModel)]="EmailProvider">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstEmail" [ngValue]="o">
				{{ o.EmailProviderEmailInfo }}
			</option>
		</select>
	</div>

	<div class="Center TopMargin">
		<button [disabled]="EmailLoaded1 == false || EmailLoaded2 == false || UpdatingEmail == true" class="btn btn-primary" (click)="onEmailUpdate()">
			Update Email
		</button>
	</div>

	<div class="TopMargin">
		<div name="EmailError" *ngIf="EmailError" class="alert alert-danger">
			{{ EmailError }}
		</div>
	</div>
</div>

<!--Password-->
<div class="MainBorder">
	<div class="Center">
		<h4>Password</h4>
	</div>

	<div class="Grid2Col">
		<label *ngIf="ConfirmPasswordWhenChanging == true" class="NoMargin">Old Password:</label>
		<input *ngIf="ConfirmPasswordWhenChanging == true" class="form-control" type="password" [(ngModel)]="OldPassword" />

		<label class="NoMargin">New Password:</label>
		<input class="form-control" type="password" [(ngModel)]="NewPassword" />

		<label class="NoMargin">Confirm Password:</label>
		<input class="form-control" type="password" [(ngModel)]="ConfirmPassword" />
	</div>

	<div class="Center TopMargin">
		<label class="InstructionLabel">{{ PasswordInstructions }}</label>
	</div>

	<div class="Center TopMargin">
		<button [disabled]="LoadingPrefs == true || PasswordUpdating == true" class="btn btn-primary" (click)="onPasswordUpdate()">Update Password</button>
	</div>

	<div class="TopMargin">
		<div name="PasswordError" *ngIf="PasswordError" class="alert alert-danger">
			{{ PasswordError }}
		</div>
	</div>
</div>

<!--MFA-->
<div class="MainBorder">
	<div class="Center">
		<h4>Multi-Factor Authentication</h4>
	</div>

	<div>
		<ul class="InstructionList">
			<li>
				If MFA is enabled, users will have to set up an app like Microsoft Authenticator and will receive a QR code the next time they log in. Whenever
				you login you will have to enter a code from an app after entering your username and password.
			</li>
			<li>
				Districts can turn on MFA which forces everyone to use it, Schools can turn on MFA to force everyone who has access to the school to use it, and
				users can use this popup to opt-in to using MFA if it is not already turned on.
			</li>
			<li>
				<span style="font-weight: bold">Update MFA Settings</span> lets you opt-in or opt-out of MFA (NOTE: You can't opt-out of it if the district or
				one of your schools turns it on.)
			</li>
			<li>
				<span style="font-weight: bold">Reset MFA Registration</span>
				means you will get a new QR code to register for MFA the next time you log in. If you already have MFA set up in Authenticator, your old entry
				will no longer work and should be deleted. (NOTE: If you need a new QR code you can also contact a Sysadmin to have your registration reset.)
			</li>
		</ul>
	</div>

	<div
		[ngClass]="{
			Grid2Col: MFAMessage == '',
			Grid3Col: MFAMessage != ''
		}"
	>
		<label class="NoMargin">Enabled:</label>
		<input
			[disabled]="MFACanEdit == false || LoadingMFA == true || MFAUpdating == true || MFAResetting == true"
			class="form-control CHK"
			type="checkbox"
			[(ngModel)]="MFAEnabled"
		/>
		<label *ngIf="MFAMessage" style="color: blue">{{ MFAMessage }}</label>
	</div>

	<div class="Center TopMargin">
		<button
			[disabled]="MFACanEdit == false || LoadingMFA == true || MFAUpdating == true || MFAResetting == true"
			class="btn btn-primary"
			(click)="onMFAUpate()"
		>
			Update MFA Settings
		</button>
	</div>

	<div class="Center TopMargin">
		<button
			[disabled]="LoadingMFA == true || MFARegistered == false || MFAUpdating == true || MFAResetting == true"
			class="btn btn-danger"
			(click)="onResetMFA()"
		>
			Reset MFA Registration
		</button>
	</div>

	<div class="TopMargin">
		<div name="MFAError" *ngIf="MFAError" class="alert alert-danger">
			{{ MFAError }}
		</div>
	</div>
</div>

<!--Default Page-->
<div class="MainBorder">
	<div class="Center">
		<h4>Default Page</h4>
	</div>

	<div class="Grid2Col">
		<label class="NoMargin">Page:</label>

		<select
			[disabled]="LoadingDefaultPage == true || DefaultPageUpdating == true || DefaultPageResetting == true"
			class="form-control"
			name="SelectedDefaultPage"
			[(ngModel)]="SelectedDefaultPage"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDefaultPages" [ngValue]="o">
				{{ o.Desc }}
			</option>
		</select>

		<!--
        <p-dropdown style="margin-left: 5px;" [disabled]="LoadingDefaultPage == true || DefaultPageUpdating == true || DefaultPageResetting == true" [options]="lstDefaultPages" [(ngModel)]="SelectedDefaultPage" optionLabel="Desc" [filter]="true" filterBy="Desc" [showClear]="false" placeholder="Select a Page">
            <ng-template pTemplate="selectedItem">
                <div *ngIf="SelectedDefaultPage"> 
                    <div class="form-control NoBorder" style="text-align: left;">{{SelectedDefaultPage.Desc}}</div>
                </div>
            </ng-template>
            <ng-template let-PageItem pTemplate="item">
                <div>
                    <div class="form-control NoBorder" style="text-align: left;">{{PageItem.Desc}}</div>
                </div>
            </ng-template>
        </p-dropdown>
        -->
	</div>

	<div class="Center TopMargin">
		<button
			[disabled]="LoadingDefaultPage == true || DefaultPageUpdating == true || DefaultPageResetting == true"
			class="btn btn-primary"
			(click)="onDefaultPageUpate()"
		>
			Update Settings
		</button>
	</div>

	<div class="Center TopMargin">
		<button
			[disabled]="LoadingDefaultPage == true || DefaultPageAlreadySet == false || DefaultPageUpdating == true || DefaultPageResetting == true"
			class="btn btn-danger"
			(click)="onResetDefaultPage()"
		>
			Reset Settings
		</button>
	</div>

	<div class="TopMargin">
		<div name="DefaultPageError" *ngIf="DefaultPageError" class="alert alert-danger">
			{{ DefaultPageError }}
		</div>
	</div>
</div>

<!--Staff Portal App Registration-->
<div *ngIf="PortalAppTurnedOn == true" class="MainBorder">
	<div class="Center">
		<h4>Staff Portal App Registration</h4>
	</div>

	<div class="QRInstructionDiv">
		<ul>
			<li>Download the CAASS Staff Portal App from the App Store</li>
			<li>Open the App. It will ask you to register</li>
			<li>Use the app to scan the QR code below to get set up.</li>
		</ul>
	</div>

	<div class="QRBorder">
		<img [src]="StaffPortalQRB64" />
	</div>
</div>

<!--Buttons-->
<div class="Center">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
